// ===== On-screen messages =====
// Replaces alert(): a message slides up above the tab bar instead of a
// system dialog that blocks the app (and needs two hands on a phone).
// Callable from anywhere — components and the sync code above alike —
// and shown by <Toaster> in MedicationApp.
//   tone: 'error' (default) | 'info'
//   action: { label, onClick } — e.g. Undo; tapping it closes the message
export const toastListeners = new Set();
let toastSeq = 0;
export function notify(message, { tone = 'error', action = null, duration } = {}) {
  const toast = { id: ++toastSeq, message, tone, action, duration: duration || (action ? 7000 : 4000) };
  toastListeners.forEach(fn => fn(toast));
  return toast.id;
}
